// extracted by mini-css-extract-plugin
export default {"post_detail":"PostDetail_post_detail__5J3S8","tags":"PostDetail_tags__pY4Ls","createdby":"PostDetail_createdby__lRJJD"};